module.exports = __webpack_public_path__ + "img/PrevisThumbnail.3273aa32.gif";